export class PageInfo {
    PageSize: number = 0;
    Page: number = 0;
}